import './assets/styles.css'

import { createApp } from 'vue/dist/vue.esm-bundler'
import { createRouter, createWebHistory } from 'vue-router'

import VueHighlightJS from 'vue3-highlightjs'
import 'highlight.js/styles/solarized-light.css'

import MixinPageTitle from './components/common/mixins/PageTitle';


// 1. Define route components.
import App from './components/App.vue'
import PageIndex from './components/index/Page.vue';
import PageLibrary from './components/library/CategoriesPage.vue';
import SingleFullPageLibrary from './components/library/SingleFullPage.vue';
import PageNotFound from './components/error/PageNotFound.vue';

import uiLibraryComponents from './libraries/ui';

// 2. Define some routes
const routes = [
    { path: '/', component: PageIndex },
    {
        name: 'uiComponentRoot',
        path: '/ui',
        component: PageLibrary,
        props: () => ({
            title: "UI Components",
            initialComponentName: '',
            componentList: uiLibraryComponents
        })
    },
    {
        name: 'uiComponentSpecific',
        path: '/ui/:component',
        component: PageLibrary,
        props: (route: any) => ({
            title: "UI Components",
            initialComponentName: route.params.component,   
            componentList: uiLibraryComponents
        })
    },
    {
        name: 'uiComponentFullPage',
        path: '/ui/:component/fullpage',
        component: SingleFullPageLibrary,
        props: (route: any) => ({
            componentName: route.params.component,
            componentList: uiLibraryComponents
        })
    },
    { path: "/:catchAll(.*)", component: PageNotFound }
];

const router = createRouter({
    history: createWebHistory(),
    routes
});


//Create and mount the root instance.
createApp(App)
    .use(router)
    .use(VueHighlightJS)
    .mixin(MixinPageTitle)
    .mount('#app');
